import React, { useCallback, useState } from 'react';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Input from 'components/Input';
import Button from 'components/Button';
import ModalHeader from 'components/ModalHeader';
import api from 'services/api';

import { toast } from 'react-toastify';
import { Container, Content } from './styles';

interface PageProps {
  closeModal: () => void;
  closeModalAndRefresh: () => void;
  id_interest_item: string | null;
}

interface LastStepProps {
  name: string;
}

const schema = yup.object().shape({
  name: yup.string().required(),
});

const AddItemtModal: React.FC<PageProps> = ({
  closeModal,
  closeModalAndRefresh,
  id_interest_item,
}) => {
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, control, errors } = useForm<LastStepProps>({
    resolver: yupResolver(schema),
  });

  const onSubmit = useCallback(
    ({ name }: LastStepProps) => {
      const data = {
        name,
        id_interest_item,
      };

      api
        .post('/interests/createChildrenInterestItem', data)
        .then((response) => {
          toast.success('Item criado com sucesso!');
          closeModalAndRefresh();
        });
    },
    [id_interest_item, closeModalAndRefresh]
  );

  return (
    <Container>
      <ModalHeader title="Novo item" closeModal={closeModal} />
      <Content>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Input
            label="Nome"
            name="name"
            register={register}
            error={!!errors.name?.message}
          />
          <Button type="submit">{loading ? 'Entrando...' : 'Salvar'}</Button>
        </form>
      </Content>
    </Container>
  );
};

export default AddItemtModal;
